import * as mobx from 'mobx';
import * as IoC from 'typescript-ioc';
import { JobType } from '../../../../../../api/jobs.dao';
import { JobDtoType, LongRunningJob } from '../../../../../../domain/jobs';
import { AttendeeRegistrationStatus } from '../../../../../../api/attendees.dao';
import { EventExecutionRuntime } from '../../../../../../domain/jobs/implementations/event-execution-runtime';

const defaultValues = {
    newAttendeeRegistrationStatus: AttendeeRegistrationStatus.APPROVED,
    sendRegistrationEmail: true
};
class AttendeeBulkUpdateFormViewModel {
    @mobx.observable
    public newAttendeeRegistrationStatus: AttendeeRegistrationStatus;
    @mobx.observable
    public sendRegistrationEmail: boolean = true;

    constructor(
        private onUpdateBulkList: () => void,
        public attendeeIds: number[],
        private saveBulkCompletedCallback?: (attendeesToUpdate: JobDtoType) => void,
        @IoC.Inject private readonly jobsPipeline = IoC.Container.get(EventExecutionRuntime)
    ) {
        this.newAttendeeRegistrationStatus = defaultValues.newAttendeeRegistrationStatus;
        this.sendRegistrationEmail = defaultValues.sendRegistrationEmail;

        this.jobsPipeline.onComplete(JobType.AttendeeUpdateBulk, () => {
            if (this.saveBulkCompletedCallback) this.saveBulkCompletedCallback.bind(this);
        });
    }

    public get bulkUpdateAttendeeJob(): LongRunningJob {
        return this.jobsPipeline.getJobByType(JobType.AttendeeUpdateBulk);
    }

    public bulkUpdateAttendeeApiCall = async (): Promise<void> => {
        const job = this.bulkUpdateAttendeeJob;
        const description = this.sendRegistrationEmail
            ? 'Attendee Status updates in progress, emails are being sent to updated Attendees'
            : 'Attendee Status updates in progress';

        if (this.saveBulkCompletedCallback) job.onComplete(this.saveBulkCompletedCallback.bind(this));

        await job.trigger({
            attendeeIds: this.attendeeIds,
            newStatus: this.newAttendeeRegistrationStatus ,
            sendRegistrationEmail: this.sendRegistrationEmail
        }, { description: description });
        return mobx.runInAction(() => this.onUpdateBulkList());
    };

    @mobx.action
    public toggleSendRegistrationEmail = (): void => {
        this.sendRegistrationEmail = !this.sendRegistrationEmail;
    };

}

export { AttendeeBulkUpdateFormViewModel };
